'use client'

import { useState } from 'react'
import { useTranslations, useLocale } from 'next-intl'

type Category = {
  slug: string
  name_fr: string
  name_es: string
  show_in_nav: boolean
  order: number
}

interface VideoFiltersProps {
  onCategoryChange: (category: string) => void
  onSortChange: (sort: string) => void
  activeCategory: string
  activeSort: string
  categories?: Category[]
}

export default function VideoFilters({ 
  onCategoryChange, 
  onSortChange, 
  activeCategory, 
  activeSort,
  categories = []
}: VideoFiltersProps) {
  const locale = useLocale()
  const tui = useTranslations('ui')

  const sortOptions = [
    { value: 'recent', label: locale === 'fr' ? 'Plus récentes' : 'Más recientes' },
    { value: 'popular', label: locale === 'fr' ? 'Plus vues' : 'Más vistas' },
    { value: 'duration', label: locale === 'fr' ? 'Durée' : 'Duración' }
  ]

  const categoryOptions = [
    { value: 'all', label: locale === 'fr' ? 'Toutes' : 'Todas' },
    ...categories.map(cat => ({
      value: cat.slug,
      label: locale === 'fr' ? cat.name_fr : cat.name_es
    }))
  ]

  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      {/* Category Filters */}
      <div className="flex flex-wrap gap-2">
        {categoryOptions.map((category) => (
          <button
            key={category.value}
            onClick={() => onCategoryChange(category.value)}
            className={`rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ${
              activeCategory === category.value
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-200'
            }`}
          >
            {category.label}
          </button>
        ))}
      </div>

      {/* Sort Dropdown */}
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-gray-700">{locale === 'fr' ? 'Trier par:' : 'Ordenar por:'}</span>
        <select
          value={activeSort}
          onChange={(e) => onSortChange(e.target.value)}
          className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
        >
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}